import React from 'react'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import { StoryCard } from 'src/common/components/StoryCard/StoryCard'
import { StoryClientType } from 'src/strapi/types/storiesTypes'

import s from './StoriesCards.module.scss'

export type StoriesCardsProps = {
  stories: Array<StoryClientType>
}

export const StoriesCards: React.FC<StoriesCardsProps> = ({ stories }) => {
  return (
    <ContentSection className="container">
      <div className={s.StoriesCards__grid}>
        {stories.map((story, i) => (
          <StoryCard key={i} {...story} />
        ))}
      </div>
    </ContentSection>
  )
}
